module.exports = __webpack_public_path__ + "img/东华大学.e6a14947.png";